"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FormContexts_1 = require("./Contexts/FormContexts");
const react_final_form_1 = require("react-final-form");
const final_form_arrays_1 = __importDefault(require("final-form-arrays"));
const FormRenderer_1 = __importDefault(require("./FormRenderer"));
const GroupComponent_1 = __importDefault(require("./FormComponents/GroupComponent"));
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
const mapHelpers_1 = require("./utils/mapHelpers");
const InputFieldComponent_1 = require("./FormComponents/InputFieldComponent");
const MediaComponent_1 = require("./FormComponents/MediaComponent");
const TextHeader_1 = require("./FormComponents/TextHeader");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const lodash_1 = __importDefault(require("lodash"));
const ConditionalChildren_1 = require("./wrappers/ConditionalChildren");
const MediaFileComponent_1 = require("./FormComponents/MediaFileComponent");
const mutators = Object.assign({}, final_form_arrays_1.default);
// const accessors = { METADATA: () => ({ timeFormOpened: new Date() }), STATE: () => ({}) };
const FormComponent = react_1.default.memo(props => {
    const lastErrorState = (0, react_1.useRef)({});
    const { onSubmit, render, template, dataMappingContext, onChange } = props;
    const { getFiles } = (0, FormContexts_1.useFileManager)();
    const { fieldValidationWarnings } = (0, FormContexts_1.useFieldValidation)();
    // const { accessors } = useFormDataMappingSources();
    // use Memo here might reduce some rendering;
    const renderForm = (0, react_1.useCallback)(() => react_1.default.createElement(FormRenderer_1.default, { template: template }), [template]);
    const [initialValues, setInitialValues] = (0, react_1.useState)({});
    const [currentWarnings, setCurrentWarnings] = (0, react_1.useState)({});
    const [localAccessors, setLocalAccessors] = (0, react_1.useState)(dataMappingContext.accessors);
    const [initialValuesRan, setInitialValuesRan] = (0, react_1.useState)(false);
    const [firstErrorMap, setFirstErrorMap] = (0, react_1.useState)(false);
    const [firstWarningMap, setFirstWarningMap] = (0, react_1.useState)(false);
    const errorRefs = (0, react_1.useMemo)(() => {
        if (template.errorMaps) {
            let result = {};
            lodash_1.default.each(template.errorMaps, map => {
                const newRefs = (0, ConditionalChildren_1.getRefs)(map, ['FORM']);
                const keys = Object.keys(newRefs);
                if (keys.length > 0) {
                    for (const key of keys) {
                        const mergedValue = lodash_1.default.union(result[key], newRefs[key]);
                        result = Object.assign(Object.assign({}, result), { [key]: mergedValue });
                    }
                }
            });
            return result;
        }
        else {
            return {};
        }
    }, [template.errorMaps]);
    const warningRefs = (0, react_1.useMemo)(() => {
        if (template.warningMaps) {
            let result = {};
            lodash_1.default.each(template.warningMaps, map => {
                const newRefs = (0, ConditionalChildren_1.getRefs)(map, ['FORM']);
                if (Object.keys(newRefs).length > 0) {
                    result = lodash_1.default.merge(result, newRefs);
                }
            });
            return result;
        }
        else {
            return {};
        }
    }, [template.warningMaps]);
    const [previousState, setPreviousState] = (0, react_1.useState)({});
    const [previousStateWarnings, setPreviousStateWarnings] = (0, react_1.useState)({});
    const [previousErrors, setPreviousErrors] = (0, react_1.useState)({});
    //set the initialDataMap, but only if it's not been done before
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEmpty(localAccessors) && !lodash_1.default.isEmpty(dataMappingContext.accessors)) {
            setLocalAccessors(dataMappingContext.accessors);
        }
    }, [dataMappingContext.accessors, localAccessors]);
    const getRepeatableDefaults = (0, react_1.useCallback)((form) => {
        const defaultValue = {};
        Object.keys(form).forEach(key => {
            var _a, _b, _c, _d, _e;
            if (((_a = form[key].repeats) === null || _a === void 0 ? void 0 : _a.enabled) && ((_b = form[key].repeats) === null || _b === void 0 ? void 0 : _b.max) !== 1) {
                defaultValue[key] = [];
                const valuesWithNestedResults = form[key].template
                    ? getRepeatableDefaults((_c = form[key].template) === null || _c === void 0 ? void 0 : _c.components)
                    : undefined;
                for (let i = 0; i < ((_d = form[key].repeats) === null || _d === void 0 ? void 0 : _d.min); i++) {
                    defaultValue[key].push(valuesWithNestedResults);
                }
            }
            else {
                if (form[key].template) {
                    const nonRepeatedGroupNestedItems = getRepeatableDefaults((_e = form[key].template) === null || _e === void 0 ? void 0 : _e.components);
                    defaultValue[key] = nonRepeatedGroupNestedItems;
                }
            }
        });
        return defaultValue;
    }, []);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEmpty(localAccessors) && initialValuesRan === false) {
            setInitialValuesRan(true);
            if (template.initialDataMap) {
                gen5_datamapping_lib_1.mapScenarios.INITIAL_DATA_MAPPING.evaluate(template.initialDataMap, localAccessors, props.functionDefinitions).then(result => {
                    const repeatableDefaults = getRepeatableDefaults(template.components);
                    const res = Object.assign(Object.assign({}, repeatableDefaults), result);
                    setInitialValues(res);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValuesRan, localAccessors, props.functionDefinitions, template.initialDataMap, template.components]);
    const evaluateWarnings = (0, react_1.useCallback)(async (values) => {
        if (template.warningMaps &&
            (!firstWarningMap || (warningRefs && (0, ConditionalChildren_1.anyValuesChanged)(warningRefs['FORM'], previousStateWarnings, values)))) {
            const formLevelWarnings = await (0, mapHelpers_1.formWarningMapEvaluator)(Object.assign(Object.assign({}, localAccessors), { FORM: () => values }), props.functionDefinitions, template.warningMaps);
            //convert to output format
            const warnings = formLevelWarnings.reduce((acc, warning, index) => (Object.assign(Object.assign({}, acc), { [String(index)]: warning })), {});
            setPreviousStateWarnings(lodash_1.default.cloneDeep(values));
            setFirstWarningMap(true);
            // try to avoid an infinite loop
            if (!(0, lodash_isequal_1.default)(warnings, currentWarnings)) {
                setCurrentWarnings(warnings); // form level warnings
            }
        }
    }, [
        localAccessors,
        currentWarnings,
        template.warningMaps,
        props.functionDefinitions,
        previousStateWarnings,
        setPreviousStateWarnings,
        firstWarningMap,
        warningRefs,
    ]);
    const getErrors = (0, react_1.useCallback)(async (values) => {
        onChange && onChange(values);
        // This is a bit weird, but since final form doesn't support warnings, we're going to kick off warning processing inside the errors call
        evaluateWarnings(values);
        // Final form expects that these will be in an object form, where the key is a path to the form value that failed.
        // In our case, there is no form path, so we just send back with keys matching the passed in indexes
        if (template.errorMaps &&
            (!firstErrorMap || (errorRefs && (0, ConditionalChildren_1.anyValuesChanged)(errorRefs['FORM'], previousState, values)))) {
            const errors = await (0, mapHelpers_1.formErrorMapEvaluator)(Object.assign(Object.assign({}, localAccessors), { FORM: () => values }), props.functionDefinitions, template.errorMaps);
            const outErrors = errors.reduce((acc, warning, index) => (Object.assign(Object.assign({}, acc), { [String(index)]: warning })), {});
            setPreviousState(lodash_1.default.cloneDeep(values));
            setPreviousErrors(outErrors);
            setFirstErrorMap(true);
            return outErrors;
        }
        else {
            return previousErrors;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        localAccessors,
        evaluateWarnings,
        template.errorMaps,
        previousState,
        setPreviousState,
        setPreviousErrors,
        previousErrors,
        firstErrorMap,
        errorRefs,
    ]);
    const handleRender = (0, react_1.useCallback)((props) => {
        const { handleSubmit, errors, validating, dirty, form } = props;
        //Clean warnings to show only for fields that exist on the current form.
        //TODO: move this into the current getError method and refactor this page to clean up.
        const visibleComponentsFieldWarnings = {};
        if (fieldValidationWarnings) {
            Object.keys(fieldValidationWarnings).forEach(field => {
                var _a;
                if (form.getFieldState(field) && fieldValidationWarnings[field]) {
                    visibleComponentsFieldWarnings[field] = (_a = fieldValidationWarnings[field]) === null || _a === void 0 ? void 0 : _a.join(', ');
                }
            });
        }
        // keep track of previous errors so we can continue to display them while validating
        const currentErrors = validating ? lastErrorState.current : errors;
        if (!validating)
            lastErrorState.current = errors;
        return (render &&
            render({
                handleSubmit,
                renderForm,
                formChanged: dirty,
                errors: currentErrors,
                warnings: Object.assign({}, currentWarnings),
                fieldLevelWarnings: visibleComponentsFieldWarnings,
            }));
    }, [currentWarnings, render, renderForm, fieldValidationWarnings]);
    // We wait to render our first time until we have calculated our initial values, this is because
    //   changing them after the first render has no effect in final-form
    const handleSubmit = (0, react_1.useCallback)((data) => onSubmit({ data, files: getFiles() }), [getFiles, onSubmit]);
    return !lodash_1.default.isEmpty(localAccessors) ? (react_1.default.createElement(react_final_form_1.Form, { onSubmit: handleSubmit, initialValues: initialValues, mutators: mutators, validate: getErrors, validateOnBlur: false, render: handleRender })) : (react_1.default.createElement(react_1.default.Fragment, null));
});
FormComponent.displayName = 'FormComponent';
const initFormRootRenderer = (controlProvider, translate) => {
    /**
     * This function takes a list of the controls to build and builds the output controls using the typical
     * form control capabilities(repeatable, conditional, validated and read only )
     * @param componentNames names of all controls to build
     */
    const buildTypicalInputControls = (componentNames) => {
        return componentNames.reduce((acc, componentName) => {
            return Object.assign(Object.assign({}, acc), { [componentName]: (0, InputFieldComponent_1.generateInputFieldComponent)(controlProvider, componentName, translate) });
        }, {});
    };
    /**
     * Similar to above, this builds input controls, though this also includes access to the file management
     * props
     * @param componentNames names of media/file controls to buile
     */
    const buildFileControls = (componentNames) => {
        return componentNames.reduce((acc, componentName) => {
            return Object.assign(Object.assign({}, acc), { [componentName]: (0, MediaComponent_1.generateMediaComponent)(controlProvider, componentName, translate) });
        }, {});
    };
    /**
     * Similar to above, this builds input controls, though this also includes access to the file management
     * props
     * @param componentNames names of media/file controls to buile
     */
    const buildFileNameControls = (componentNames) => {
        return componentNames.reduce((acc, componentName) => {
            return Object.assign(Object.assign({}, acc), { [componentName]: (0, MediaFileComponent_1.generateMediaFileComponent)(controlProvider, componentName, translate) });
        }, {});
    };
    // Build out the full control map, wrapping our handler code around the UI code provided by the consumer
    const controlMap = Object.assign(Object.assign(Object.assign(Object.assign({}, buildTypicalInputControls([
        'barcode',
        'checkbox',
        'currency',
        'computed',
        'date',
        'location',
        'floorPlanLocation',
        'polyline',
        'mapAggregateSelector',
        'numberInput',
        'radio',
        'select',
        'textArea',
        'textInput',
        'time',
    ])), buildFileControls(['signature', 'imageupload', 'videoupload', 'audioupload'])), buildFileNameControls(['fileupload'])), { textheader: controlProvider.textheader ? (0, TextHeader_1.generateTextHeader)(controlProvider) : undefined, group: GroupComponent_1.default, RootWrapper: controlProvider.RootWrapper, RepeatWrapper: controlProvider.RepeatWrapper, GroupWrapper: controlProvider.GroupWrapper });
    /**
     * The FormComponent is the primary component used to render the form. It is created after the initFormRootRenderer
     * builds it using the passed in control map
     * @param onSubmit called by react final form when the form is submitted
     * @param render render prop called with the form, warnings, errors, etc
     * @param template the template to render
     */
    const FormRootRenderer = props => {
        const { dataMappingContext } = props, rest = __rest(props, ["dataMappingContext"]);
        const value = (0, react_1.useMemo)(() => {
            return { controlMap, functionDefinitions: props.functionDefinitions };
        }, [props.functionDefinitions]);
        return (react_1.default.createElement(FormContexts_1.FieldValidationContextProvider, null,
            react_1.default.createElement(FormContexts_1.FileManagementContextProvider, null,
                react_1.default.createElement(FormContexts_1.ControlProviderContext.Provider, { value: value },
                    react_1.default.createElement(FormContexts_1.FormDataMappingContext.Provider, { value: dataMappingContext },
                        react_1.default.createElement(FormComponent, Object.assign({}, rest, { dataMappingContext: dataMappingContext })))))));
    };
    return FormRootRenderer;
};
exports.default = initFormRootRenderer;
